import {I18n as T18n} from 'i18n-js'

// Translations arrive in the locales/<locale> packs, which the layout loads
// right after this one (see Glassfrog::I18n::TranslationPacks).
const I18n = new T18n()

I18n.enableFallback = true
window.I18n = I18n

export default I18n
